import Swal from 'sweetalert2';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { clearMessage } from '@store/messageSlice';

const ErrorAlert = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { message, type } = useSelector((state) => state.infoMessage);

  // 리다이렉트가 필요한 메시지를 배열로 관리
  const redirectMessages = [
    '잘못된 접근입니다.',
    '로그인이 필요합니다. <br/> 초기화면으로 이동합니다.',
    '회사코드가 없습니다. <br/> 초기화면으로 이동합니다.',
    '동일한 아이디가 접속되어 로그아웃되었습니다.',
    '로그아웃 되었습니다.',
    '회사코드와 ID가 일치하지 않습니다.'
  ];

  useEffect(() => {
    const showAlert = async () => {
      if (!message) return;

      const result = await Swal.fire({
        html: message,
        icon: type,
        confirmButtonText: '확인',
        confirmButtonColor: '#3085d6',
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      if (result.isConfirmed) {
        //메시지가 리다이렉트 조건에 해당하면 메인으로 이동
        if (redirectMessages.includes(message)) {
          const companyCode = localStorage.getItem("companyCode");
          const userInfo = localStorage.getItem("userInfo");

          if (companyCode) localStorage.removeItem("companyCode");
          if (userInfo) localStorage.removeItem("userInfo");
          navigate('/');
        }

        dispatch(clearMessage()); // 메시지 상태 초기화
      }
    };

    showAlert();
  }, [message, type, dispatch, navigate]); // 의존성 배열에 필요 항목 추가

  return null;
};

export default ErrorAlert;
